// drop.js (refonte ES6 stricte et complète sans suppression de logique)
import $ from 'jquery';
import search from './search';

const drop = {
	get_result: false,
	_id: '',

	init() {
		$(document).on('click', '.__close_drop > span', () => {
			$('._menu_dropdown').removeClass('_show');
			this.get_result = false;
			this.cleanResult();
			search.fromMenu = false;
		});

		$(document).on('click', '._menu_drop', function () {
			drop._id = $(this).data('drop');

			if ($(this).hasClass('_menu_drop_search')) {
				search.fromMenu = true;
			}

			$('._menu_drop').removeClass('_opened');
			$(this).addClass('_opened');
			$(this).find('input').attr('readonly', true);

			if ($(this).hasClass('_drop_result')) {
				drop.get_result = true;
				drop.putResult();
			} else {
				drop.get_result = false;
				drop.cleanResult();
			}

			$('._menu_dropdown').removeClass('_show');
			$(`._menu_dropdown[data-drop="${drop._id}"]`).addClass('_show');
		});

		$(window).on('click', (event) => {
			if (
				!event.target.closest('._menu_drop') &&
				!event.target.closest('._menu_dropdown') &&
				!event.target.closest('.--product_hours > .__select_ophorus')
			) {
				$('._menu_dropdown').removeClass('_show');
				drop.get_result = false;
				search.fromMenu = false;
				drop.cleanResult();
			}
		});
	},

	putResult() {
		$(document).on(
			'change',
			`._menu_dropdown[data-drop="${this._id}"] > .__bl_line > .__ul_checkbox > li > .cc-checkbox-outer > input[type=checkbox]`,
			function () {
				let label = '';
				let tooLong = false;
				let count = 0;

				$(`._menu_dropdown[data-drop="${drop._id}"] input`).each(function () {
					if ($(this).prop('checked')) {
						count++;
						label += $(this).data('label') + ' - ';
						if (label.length > 20) {
							label = label.substr(0, 20) + ' ...   ';
							tooLong = true;
						}
					}
				});

				$(`._menu_drop[data-drop="${drop._id}"] > input`).val(label.slice(0, -3));
				const badge = $(`._menu_drop[data-drop="${drop._id}"]`).find('._nb_drop');
				if (tooLong) {
					badge.html(count).show();
				} else {
					badge.hide();
				}
			}
		);

		$(document).on(
			'click',
			`._menu_dropdown[data-drop="${this._id}"] > .mCustomScrollBox > .mCSB_container > .__bl_line > .__ul_select > li`,
			function () {
				const label = $(this).data('label');
				const id = $(this).data('id');

				$(this).siblings().removeClass('_activ');
				$(this).addClass('_activ');
				$(`._menu_drop[data-drop="${drop._id}"] > input`).val(label);
				$('._menu_dropdown').removeClass('_show');
				$(`._menu_drop[data-drop="${drop._id}"] > input`).attr('readonly', false);

				$(document).off(
					'click',
					`._menu_dropdown[data-drop="${drop._id}"] > .mCustomScrollBox > .mCSB_container > .__bl_line > .__ul_select > li`
				);

				// if(transfers.active===true){ ... }

				drop.get_result = false;
				drop.cleanResult();
			}
		);
	},

	cleanResult() {
		$('._menu_drop').removeClass('_opened');
		if (this._id !== undefined) {
			$(document).off(
				'click',
				`._menu_dropdown[data-drop="${this._id}"] > .mCustomScrollBox > .mCSB_container > .__bl_line > .__ul_select > li`
			);
			$(document).off(
				'change',
				`._menu_dropdown[data-drop="${this._id}"] > .__bl_line > .__ul_select > li`
			);
			this._id = '';
		}
	}
};

export default drop;
